const USER_INSIGHTS_STORAGE_KEY = "eh_ui_fired";
const isWindowDefined = typeof window !== "undefined";
let userInsights = {
  fired: isWindowDefined ? sessionStorage.getItem(USER_INSIGHTS_STORAGE_KEY) === "true" : false,
  insights: {}
};
const setUserInsights = (userInsight) => {
  userInsights = userInsight;
  if (isWindowDefined) {
    sessionStorage.setItem(USER_INSIGHTS_STORAGE_KEY, userInsight.fired.toString());
  }
};
export {
  setUserInsights,
  userInsights
};
